var $0a371f9c1df8120f$exports = {};
$0a371f9c1df8120f$exports = {
    "Clear search": `Ryd s\xf8gning`
};


export {$0a371f9c1df8120f$exports as default};
//# sourceMappingURL=da-DK.mjs.map
